import { TenantRequestModel } from '../details-overlay.model';
import { AbstractRequestClass, DetailRequestModel } from './abstract-request.class';

export class LeaseSpaceRequestClass extends AbstractRequestClass {
  declare private updateRequest: DetailRequestModel;

  declare private _lease: Record<string, any>;
  declare private _floorSuite: Record<string, any>;
  declare private _floors: Record<string, any>[];
  private static _staticFloors: Record<string, any>[];

  constructor(params: Record<string, any>, edpMethod: string, floors?: Record<string, any>[]) {
    LeaseSpaceRequestClass._staticFloors = floors || [];
    super(params, edpMethod);
    this._floors = LeaseSpaceRequestClass._staticFloors;
  }

  protected init({ lease = {}, ...params }: TenantRequestModel): void {
    if (!this._floors?.length && LeaseSpaceRequestClass._staticFloors?.length) {
      this._floors = LeaseSpaceRequestClass._staticFloors;
    }

    this._lease = lease;
    this._floorSuite = lease.floor_suite?.find?.(f => f.id === params.spaceId);
    super.init(params);
  }

  public getLease(): Record<string, any> {
    return this._lease;
  }

  protected setParamsPayload(params: Record<string, any>): void {
    const tenantParams = params as TenantRequestModel;
    this.setUpdateRequest(tenantParams);
  }

  public getMultiEndPoints(): DetailRequestModel[] | null {
    return [this.updateRequest];
  }

  public getMappingRequest(): Record<string, any> {
    return {};
  }

  private setUpdateRequest(params: TenantRequestModel): void {
    // Validate that spaceId is present for identification
    if (
      this._floorSuite == null ||
      this._floorSuite.id == null ||
      this._floorSuite.floor_id === '' ||
      this._floorSuite.suite_id === 0
    ) {
      throw new Error('SpaceId is required for lease space update operation');
    }

    const payload = this.getCommonRequest(params);

    payload.propAssociation.floor_suite = [
      {
        // Form Data Fields (from TenantRequestModel)
        arrangement_space_area: params.spaceSize,
        ref_arrangement_space_area_uom_desc: params.spaceSizeUOM,
        floor_number: `${params.floorNumber ?? ''}`,
        suite_number: `${params.suiteNumber ?? ''}`,
        tenancy_start_date: params.leaseStartDate,
        tenancy_end_date: params.leaseEndDate,
        occupancy_date: params.spaceOccupancyDate,
        tenancy_status_desc: params.spaceLeaseStatus,
        full_floor_f: params.full_floor_f ?? this._floorSuite?.full_floor_f,
        // Preserved Fields (from existing lease space data)
        // Primary identifier for the lease space record
        id: this._floorSuite?.id,
        floor_id: this._floorSuite?.floor_id,
        suite_id: this._floorSuite?.suite_id,
        property_arrangement_status_type_desc: this._floorSuite?.property_arrangement_status_type_desc,
        space_lease_activity_type_desc: this._floorSuite?.space_lease_activity_type_desc,
        alternate_address_id: this._floorSuite?.alternate_address?.id,
        terrace_f: this._floorSuite?.terrace_f,
        terrace_area: this._floorSuite?.terrace_area,
        terrace_area_uom: this._floorSuite?.terrace_area_uom,
        arrangement_floor_desc: this._floorSuite?.arrangement_floor_desc,
        space_asking_rate_yearly: this._floorSuite?.space_asking_rate_yearly,
        space_asking_rate_yearly_uom: this._floorSuite?.space_asking_rate_yearly_uom,
        space_rate_type_desc: this._floorSuite?.space_rate_type_desc,
        space_base_rent_yearly: this._floorSuite?.space_base_rent_yearly,
        space_base_rent_yearly_uom: this._floorSuite?.space_base_rent_yearly_uom,
        fb_license_desc: this._floorSuite?.fb_license_desc,
        itza_space_type_desc: this._floorSuite?.itza_space_type_desc,
        itza_area_percent: this._floorSuite?.itza_area_percent,
        surface_area_estimated_f: this._floorSuite?.surface_area_estimated_f,
        arrangement_space_leased_area: this._floorSuite?.arrangement_space_leased_area,
        arrangement_space_leased_area_uom: this._floorSuite?.arrangement_space_leased_area_uom,
      },
    ];

    this.updateRequest = {
      method: 'miqUpdateLeaseArrangementPropertyFloorSuite',
      payload,
      order: 0,
    };
  }

  private getCommonRequest(params: TenantRequestModel): Record<string, any> {
    return {
      request: { source_id: params.tenantId },
      lease_id: params.tenantId,
      propAssociation: { property_id: params.propertyId, property_usage_id: params.propertyUsageId, floor_suite: [] },
    };
  }
}
